import { useCookie } from "@/@core/composable/useCookie"
import { router } from "@/plugins/1.router"
import { ability } from "@/plugins/casl"
import CommonService from "@/services/CommonService"
export const useAuthStore = defineStore("authStore", {
  state: () => ({
    accessToken: useCookie("accessToken").value,
    user: useCookie("user").value,
    profileUser: JSON.parse(localStorage.getItem("profileUser")) || null,
    userAbilityRules: useCookie("userAbilityRules").value,
    userSubRoles: useCookie("userSubRoles").value,
    schoolStaffId: useCookie("schoolStaffId").value,
    isAdmin: useCookie("isAdmin").value || null,
    profileCache: null,
    routeSurvey: null,
    reportStudent: null
  }),
  getters: {
    getQueryAuth: (state) => {
      return btoa(
        CommonService.generateJWT(state.user.email, state.accessToken)
      )
    },
    getProfileUser(state) {
      return state.profileCache || state.profileUser
    },
  },
  actions: {
    login(response, route) {
      const { accessToken, user, userAbilityRules, schoolStaffId } = response
      console.log("loging in userAbilityRules", response)
      useCookie("userAbilityRules").value = userAbilityRules
      useCookie("user").value = user
      useCookie("schoolStaffId").value = schoolStaffId
      useCookie("accessToken").value = accessToken
      useCookie("userSubRoles").value = user?.subRoles
      ability.update(userAbilityRules)
      this.accessToken = accessToken
      this.user = user
      this.userAbilityRules = userAbilityRules
      this.schoolStaffId = schoolStaffId
      this.userSubRoles = user?.subRoles
      if (user?.termsAccepted) {
        router.push({ name: "home" })
      } else {
        router.push(route.query.to ? String(route.query.to) : "/reglement")
      }
    },
    loginByCreatePassword(response, route) {
      const { accessToken, user, schoolStaffId } = response
      console.log("loging in userAbilityRules", response)
      useCookie("user").value = user
      useCookie("schoolStaffId").value = schoolStaffId
      useCookie("accessToken").value = accessToken
      useCookie("userSubRoles").value = user?.subRoles
      this.accessToken = accessToken
      this.user = user
      this.schoolStaffId = schoolStaffId
      this.userSubRoles = user?.subRoles
      if (user?.termsAccepted) {
        router.push({ name: "home" })
      } else {
        router.push({ name: "reglement" })
      }
    },

    loginByRoute(response, isAdmin) {
      const { user, userAbilityRules, schoolStaffId } = response

      useCookie("userAbilityRules").value = userAbilityRules
      useCookie("user").value = user
      useCookie("schoolStaffId").value = schoolStaffId
      useCookie("isAdmin").value = isAdmin

      this.user = user
      this.userAbilityRules = userAbilityRules
      this.schoolStaffId = schoolStaffId
      this.isAdmin = isAdmin
      if (this.routeSurvey) {
        router.push(`/survey/${this.routeSurvey}`)
        return
      }
      if (this.reportStudent) {
        router.push(this.reportStudent)
        return
      }
      if (user?.termsAccepted) {
        router.push({ name: "home" })
      } else {
        router.push({ name: "reglement" })
      }
    },
    logout() {
      useCookie("user").value = null
      useCookie("accessToken").value = null
      useCookie("userAbilityRules").value = null
      useCookie("userSubRoles").value = null
      useCookie("schoolStaffId").value = null
      useCookie("email").value = null
      useCookie("lang").value = null
      useCookie("isAdmin").value = null
      useCookie("listReport").value = null
      localStorage.removeItem("profileUser")
      localStorage.removeItem("listReport")
      this.user = null
      this.accessToken = null
      this.userAbilityRules = null
      this.profileUser = null
      this.isAdmin = null
      ability.update({
        action: "read",
        subject: "Auth",
      })
      router.push({ name: "index" }).then(() => {
        window.location.reload()
      })
    },
    reset(redirect) {
      useCookie("user").value = null
      useCookie("accessToken").value = null
      useCookie("userAbilityRules").value = null
      useCookie("userSubRoles").value = null
      useCookie("schoolStaffId").value = null
      useCookie("email").value = null
      localStorage.removeItem("profileUser")
      this.user = null
      this.accessToken = null
      this.userAbilityRules = null
      this.profileUser = null
      ability.update({
        action: "read",
        subject: "Auth",
      })
    },

    setUser(newUser) {
      useCookie("user").value = newUser
      useCookie("accessToken").value = newUser
      this.user = newUser
      this.accessToken = newUser
    },
    setDataUser(newUser) {
      useCookie("user").value = newUser
      this.user = newUser
      console.log("updated user in store", this.user)
    },

    setProfileUser(newUser) {
      localStorage.setItem("profileUser", JSON.stringify(newUser))
      this.profileUser = newUser
      this.profileCache = newUser
    },
    setSurveyRoute(route) {
      this.routeSurvey = route
    },
    setRedirectReportStudent(redirect) {
      this.reportStudent = redirect
    },
    setAdmin(admin) {
      useCookie("isAdmin").value = admin
      this.isAdmin = admin
    }
  },
})
